import { Grid, withWidth, Typography } from "@material-ui/core";
import React from "react";
import {CssTextAreaLandingPageField, CssTextField} from "../../../../../../styles";
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ColorButton = styled(Button)(({ theme }) => ({
    color: "#fff",
    backgroundColor: "#502eff",
    width: 152,
    height: 40,
    '&:hover': {
        backgroundColor: "#5d28fa",
    },
}));

function Learn(props) {

    return (
        <React.Fragment>
            <div ref={props.requestTrial}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={props.width === 'xs' || props.width === 'sm' ? 0 : 10}
                >
                    <Grid item xs={8} sm={8}>
                        <div className="tmctabTtl">
                            <h3 style={{fontSize: 24}}>Request trial to access the portal</h3>
                            <p>Fill the form below and provide reason for trial access. <br />
                                Do provide your work or school Microsoft account for email.
                                We will be in touch</p>
                        </div>
                    </Grid>
                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={props.width === 'xs' || props.width === 'sm' ? 0 : 10}
                >
                    <Grid item xs={8} sm={8} md={4} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >First Name: </label>
                        <CssTextField
                            variant="outlined"
                            placeholder="Enter your first name"
                            required
                            value={props.formData.firstname}
                            fullWidth
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, color: "#000", backgroundColor: "#fff", borderRadius: 5 } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    firstname: val.target.value
                                }));
                                props.setFormError(prev => ({
                                    ...prev,
                                    firstname: !!!val.target.value
                                }))
                            }}
                        />
                        {
                            props.signupWilling ? props.formData.firstname === "" ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>First Name is Required</div> : props.formError.firstname ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Please enter valid first name</div> : <div /> : <div />
                        }
                    </Grid>
                    <Grid item xs={8} sm={8} md={4} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >Last Name: </label>
                        <CssTextField
                            required
                            placeholder="Enter your last name"
                            variant="outlined"
                            value={props.formData.lastname}
                            fullWidth
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, borderRadius: 5, color: "#000", backgroundColor: "#fff", } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    lastname: val.target.value
                                }));
                                props.setFormError(prev => ({
                                    ...prev,
                                    lastname: !!!val.target.value
                                }))
                            }}
                        />
                        {
                            props.signupWilling ? props.formData.lastname === "" ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Last Name is Required</div> : props.formError.lastname ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Please enter valid last name</div> : <div /> : <div />
                        }
                    </Grid>
                </Grid>
                
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={props.width === 'xs' || props.width === 'sm' ? 0 : 10}
                >
                    <Grid item xs={8} sm={8} md={4} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >Email:</label>
                        <CssTextField
                            required
                            placeholder="Enter your email"
                            variant="outlined"
                            value={props.formData.email}
                            fullWidth
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, borderRadius: 5, color: "#000", backgroundColor: "#fff", } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    email: val.target.value
                                }));
                                let pattern = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,11}$/g);
                                props.setFormError(prev => ({
                                    ...prev,
                                    email: !!!pattern.test(val.target.value)
                                }))
                            }}
                        />
                        {
                            props.signupWilling ?
                                props.formData.email === "" ? 
                                    <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Email is Required</div> 
                                    : props.formError.email ? 
                                        <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Please enter valid email</div> : <div /> : <div />
                        }
                    </Grid>
                    <Grid item xs={8} sm={8} md={4} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >Organisation: </label>
                        <CssTextField
                            variant="outlined"
                            placeholder="Enter the name of your organisation"
                            required
                            fullWidth
                            value={props.formData.org}
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, color: "#000", backgroundColor: "#fff", borderRadius: 5 } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    org: val.target.value
                                }));
                                props.setFormError(prev => ({
                                    ...prev,
                                    org: !!!val.target.value
                                }))
                            }}
                        />
                        {
                            props.signupWilling ? props.formError.org ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Organisation is Required</div> : <div /> : <div />
                        }
                    </Grid>
                </Grid>
                
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={props.width === 'xs' || props.width === 'sm' ? 0 : 10}
                >
                    <Grid item xs={8} sm={8} md={4} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >Title: </label>
                        <CssTextField
                            variant="outlined"
                            placeholder="Enter the title"
                            required
                            fullWidth
                            value={props.formData.jobTitle}
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, color: "#000", backgroundColor: "#fff", borderRadius: 5 } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    jobTitle: val.target.value
                                }));
                                props.setFormError(prev => ({
                                    ...prev,
                                    jobTitle: !!!val.target.value
                                }))
                            }}
                        />
                        {
                            props.signupWilling ? props.formError.jobTitle ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Title is Required</div> : <div /> : <div />
                        }
                    </Grid>
                    <Grid item xs={8} sm={8} md={4} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >Location/Country : </label>
                        <CssTextField
                            variant="outlined"
                            placeholder="Enter Location/Country"
                            required
                            fullWidth
                            value={props.formData.country}
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, color: "#000", backgroundColor: "#fff", borderRadius: 5 } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    country: val.target.value
                                }));
                                props.setFormError(prev => ({
                                    ...prev,
                                    country: !!!val.target.value
                                }))
                            }}
                        />
                        {
                            props.signupWilling ? props.formError.country ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Location is Required</div> : <div /> : <div />
                        }
                    </Grid>
                </Grid>
                
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={props.width === 'xs' || props.width === 'sm' ? 0 : 10}
                >
                    <Grid item xs={8} sm={8} md={8} style={{ margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <label style={{ color: "#fff", fontSize: 12, fontWeight: 500 }} >Purpose : </label>
                        <CssTextAreaLandingPageField
                            variant="outlined"
                            placeholder="Enter the purpose"
                            required
                            fullWidth
                            multiline
                            minRows={4}
                            value={props.formData.purpose}
                            inputProps={{ style: { fontSize: 14, fontWeight: 500, color: "#000", backgroundColor: "#fff", borderRadius: 5 } }}
                            onChange={(val) => {
                                val.persist();
                                props.setFormData(prev => ({
                                    ...prev,
                                    purpose: val.target.value
                                }));
                                props.setFormError(prev => ({
                                    ...prev,
                                    purpose: !!!val.target.value
                                }))
                            }}
                        />
                        {
                            props.signupWilling ? props.formError.purpose ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Purpose is Required</div> : <div /> : <div />
                        }
                    </Grid>
                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={10}
                >
                    <Grid item xs={12} style={{ textAlign: "center", margin: props.width === 'xs' || props.width === 'sm' ? "30px 0px 30px 0px" : 0 }}>
                        <ColorButton variant="contained"
                            onClick={() => { props.signUp() }}
                        >  {
                            props.requestTrialLoading ? <Spinner styles={{ root: { marginBottom: '0px' } }} size={SpinnerSize.small} /> : <Typography style={{ fontSize: 12, color: "#fff" }}>Request Now</Typography> 
                            }
                        </ColorButton>
                    </Grid>
                </Grid>
            </div>

        </React.Fragment>
    );
}

export default withWidth()(Learn);